import { configureStore } from '@reduxjs/toolkit';

import { api } from './api/api';
import { authApi } from './api/auth.api';
import { rootReducers } from './reducers';

export type TypeRootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

const store = configureStore({
  reducer: rootReducers,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({}).concat([api.middleware, authApi.middleware]),
  // devTools: process.env.NODE_ENV !== 'production',
});

export default store;
